import { render, staticRenderFns } from "./StepsTracker.vue?vue&type=template&id=1634ba00&scoped=true&"
import script from "./StepsTracker.vue?vue&type=script&lang=js&"
export * from "./StepsTracker.vue?vue&type=script&lang=js&"
import style0 from "./StepsTracker.vue?vue&type=style&index=0&id=1634ba00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1634ba00",
  null
  
)

export default component.exports